import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

import React, {Component} from 'react';
import {connect} from 'react-redux';
import store from 'store';

import Alert from 'react-s-alert';

import ReduxLoader from '../components/display/ReduxLoader';
import UniversalHeader from '../containers/navigation/UniversalHeader';
import UniversalFooter from '../containers/navigation/UniversalFooter';
import {fetchUser} from "../store/actions/user";
// import {refreshTenant} from "../containers/tenant/actions/tenant";
// import {refreshOwner} from "../containers/owner/actions/owner";

class App extends Component {
    componentWillMount() {
        this.ensureUser();
        // this.configureAutoRefresh();
    }

    //Ensure that user data is loaded into the Redux store, regardless of which route they enter at
    ensureUser = () => {
        if (!this.props.activeUser.email && store.get('type')) {
            console.log("User data not in store, fetching...");
            this.props._fetchUser();
        }
    };

    //Run refresh function that syncs with server
    // configureAutoRefresh = () => {
    //     const fetch = this.props._refreshUser;
    //     setInterval(function () {
    //         if (store.get('access_token') && store.get('type')) {
    //             fetch();
    //         }
    //     }, 30000);
    // };

    render() {
        return (
            <div>
                <UniversalHeader/>
                <ReduxLoader spin>
                    {this.props.children}
                </ReduxLoader>
                <Alert stack={{limit: 3}} effect="slide"/>
                <UniversalFooter/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    activeUser: state.activeUser
});

const mapDispatchToProps = (dispatch) => ({
    _fetchUser() {
        return dispatch(fetchUser());
    },
    // _refreshUser() {
    //     if (store.get('type') === 'tenant') return dispatch(refreshTenant());
    //     else if (store.get('type') === 'landlord') return dispatch(refreshOwner());
    // },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App.js